export default {
  SET_TIPS (state, tips) {
    state.tips = tips
  },
  UPDATE_TIP (state, { tipId, updatedFields }) {
    const tipIndex = state.tips.findIndex((t) => t.id === tipId)
    Object.assign(state.tips[tipIndex], updatedFields)
  }

}
